<h1>Добро пожаловать в RPA</h1>

<span *ngIf="usagePercent "> Занято памяти: {{usagePercent}}% ({{usage}} из {{quota}} ГБ) </span>



<dl>
    <ng-container *ngIf="user">
        <dt>
            Пользователь
        </dt>
        <dd>
            {{user.name}}
        </dd>
        <dl>
            Телефон
        </dl>
        <dd>
            {{user.Phone}}
        </dd>
        <dt>
            Подключенная база
        </dt>
        <dd>
            {{user.Server}}
        </dd>
        <dt>Токен</dt>
        <dd>{{dt(user.exp) | date:'dd.MM.yyyy hh:mm'}}</dd>
    </ng-container>
    <ng-container *ngIf="conn">
        <dt>Менеджер</dt>
        <dd>{{conn.agent.name}}</dd>
        <dt>Код</dt>
        <dd>{{conn.agent.Code}}</dd>
        <dt>Токен</dt>
        <dd>{{dt(conn.agent.exp) | date:'dd.MM.yyyy hh:mm'}}</dd>
    </ng-container>
    <ng-container *ngIf="isAdmin">
        <dt>market</dt>
        <dd><a href="{{api}}swagger">{{api}}</a></dd>
        <dt>ukrop</dt>
        <dd><a href="{{ukrop}}">{{ukrop}}</a></dd>
        <dt>prod</dt>
        <dd>{{prod}}</dd>
    </ng-container>
    <dt>deviceId</dt>
    <dd>{{deviceId}}</dd>
</dl>


